import { Link, useNavigate } from 'react-router';
import { Ico, Logo } from './brand';
import { LangToggle, useLang } from '../lib/i18n';

export function AppHeader({ cur = 'home', city, onCity }: { cur?: 'home' | 'mytickets' | 'venues' | ''; city?: string; onCity?: (c: string) => void }) {
  const { tx } = useLang();
  const nav = useNavigate();
  const cities = ['Tümü', 'İstanbul', 'İzmir'];
  return (
    <header className="ahead">
      <Link to="/" style={{ textDecoration: 'none' }} aria-label={tx('Gişe ana sayfa', 'Gişe home')}>
        <Logo size={30} />
      </Link>
      <nav className="dnav" aria-label={tx('Ana menü', 'Main menu')}>
        <button type="button" className={cur === 'home' ? 'cur' : ''} onClick={() => { nav('/'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
          {tx('Keşfet', 'Discover')}
        </button>
        <button type="button" className={cur === 'venues' ? 'cur' : ''} onClick={() => nav('/#mekanlar')}>
          {tx('Mekânlar', 'Venues')}
        </button>
        <button type="button" className={cur === 'mytickets' ? 'cur' : ''} onClick={() => nav('/biletlerim')}>
          {tx('Biletlerim', 'My tickets')}
        </button>
      </nav>
      <span className="grow" />
      <label className="city">
        <Ico n="pin" cls="ico-s" />
        <span className="sr">{tx('Şehir', 'City')}</span>
        <select
          aria-label={tx('Şehir', 'City')}
          value={city ?? 'Tümü'}
          onChange={(e) => (onCity ? onCity(e.target.value) : nav('/?city=' + encodeURIComponent(e.target.value)))}
        >
          {cities.map((c) => (
            <option key={c} value={c}>
              {c === 'Tümü' ? tx('Tümü', 'All') : c}
            </option>
          ))}
        </select>
        <Ico n="down" cls="ico-s" />
      </label>
      <LangToggle />
      <button type="button" className="icon-btn" onClick={() => nav('/biletlerim')} aria-label={tx('Biletlerim', 'My tickets')}>
        <Ico n="ticket" />
      </button>
    </header>
  );
}

export function Loading() {
  return (
    <div className="scroll">
      <div className="wrap" style={{ paddingTop: 24, display: 'grid', gap: 16 }} aria-busy="true">
        <div className="skel" style={{ height: 48, width: '40%' }} />
        <div className="skel" style={{ height: 260 }} />
        <div className="skel" style={{ height: 80 }} />
      </div>
    </div>
  );
}

export function ErrorView({ msg, action }: { msg: string; action?: React.ReactNode }) {
  return (
    <div className="scroll">
      <div className="center-msg">
        <div>
          <p className="d-m" style={{ margin: '0 0 10px' }}>{msg}</p>
          {action}
        </div>
      </div>
    </div>
  );
}
